__turbopack_context__.v({
  "container": "A0yktG_container",
  "logo": "A0yktG_logo",
  "text": "A0yktG_text",
});
